import { ChangeEvent } from 'react'

const plateFormatter = (input: HTMLInputElement) => {
  let value = input.value.toUpperCase().replace(/[^A-Z0-9]/g, '')

  const letters = value.slice(0, 3).replace(/[^A-Z]/g, '')
  let rest = value.slice(3)

  if (rest.length > 0 && !/^\d/.test(rest)) {
    rest = rest.replace(/^[A-Z]+/, '')
  }

  value = letters + rest

  if (value.length > 3) {
    value = `${value.slice(0, 3)}-${value.slice(3, 7)}`
  }

  input.value = value
}

export const plateMask = (event: ChangeEvent<HTMLInputElement>) => {
  if (event.target instanceof HTMLInputElement) {
    plateFormatter(event.target)
  }
}
